module.exports = __webpack_public_path__ + "static/media/smart-csv-export.5753c7a3.svg";